import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '@/components/ui/button';
import { Building2 } from 'lucide-react';

const NoOrgState = () => {
  const { user, refreshUser, logout } = useAuth();
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refreshUser();
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-200 p-6">
      <div className="max-w-[480px] w-full text-center bg-card p-12 rounded-2xl shadow-sm">
        <div className="w-20 h-20 mx-auto mb-6 bg-amber-50 rounded-full flex items-center justify-center text-amber-500">
          <Building2 className="h-8 w-8" />
        </div>

        <h1 className="text-2xl font-bold text-foreground mb-3">Waiting for Organization</h1>

        <p className="text-base text-muted-foreground mb-6 leading-relaxed">
          Hi {user?.name || 'there'}! Your account is set up, but you're not part of any organization yet.
        </p>

        <div className="text-left bg-slate-50 p-4 rounded-lg mb-6">
          <h3 className="text-sm font-semibold text-foreground mb-3">What happens next?</h3>
          <ul className="list-disc pl-5 text-sm text-muted-foreground space-y-2 leading-relaxed">
            <li>Ask your organization admin to add you using your email: <strong className="text-foreground">{user?.email}</strong></li>
            <li>Once added, refresh this page to access your organization</li>
          </ul>
        </div>

        <div className="flex flex-col gap-3 mb-6">
          <Button
            onClick={handleRefresh}
            disabled={refreshing}
          >
            {refreshing ? 'Checking...' : 'Check for Invitations'}
          </Button>

          <Button
            variant="outline"
            onClick={logout}
          >
            Sign Out
          </Button>
        </div>

        <p className="text-xs text-muted-foreground">
          Need help? Contact support at{' '}
          <a href="mailto:support@cornercast.tv" className="text-coral hover:underline">
            support@cornercast.tv
          </a>
        </p>
      </div>
    </div>
  );
};

export default NoOrgState;
